<div class="transcript-fulfillment" c-toggle="showView" c-toggle-options="{type: 'fade'}">
    <div c-transcript="transcript" class="child"></div>
</div>
<div ui-view></div>